import React from 'react';
import { SliderCard } from 'smart-react';
import CodeMirror from '@uiw/react-codemirror';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Label } from '@progress/kendo-react-labels';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import './CommandField.scss';
/**
 * Used to populate the Slider Card Content based on the provided action
 */
const CommandField = ({
  handleSlide,
  editorField,
  setEditorField,
  setFormData,
  formData,
  lgHeight,
  showCommandModal,
  setShowCommandModal,
  requiredField,
}) => {
  /**
   * editor value change
   */
  const onEditorValChange = React.useCallback(
    (val, viewUpdate) => {
      setEditorField({ ...editorField, value: val });
      setFormData((prev) => ({ ...prev, [editorField.name]: val }));
    },
    [editorField, formData],
  );

  return (
    <>
      {showCommandModal ? (
        <>
          <SliderCard
            handleSlide={handleSlide}
            title={editorField?.label}
            className='data-field-slider'
          >
            <SliderCard.Body>
              <div className='k-d-flex single-field-row single-row-60'>
                <CodeMirror
                  value={editorField?.value ?? ''}
                  height={lgHeight}
                  onChange={onEditorValChange}
                />
              </div>
            </SliderCard.Body>
            <SliderCard.Footer>
              <Button themeColor={'primary'} onClick={() => handleSlide()}>
                Close
              </Button>
            </SliderCard.Footer>
          </SliderCard>
        </>
      ) : (
        <>
          {editorField?.label && (
            <span className='k-floating-label-container k-label'>
              <Label editorId={editorField?.name}>
                {editorField?.label}{' '}
                {requiredField && <span className='required-field'>*</span>}
              </Label>
            </span>
          )}
          <CodeMirror
            value={editorField?.value ?? ''}
            height={'10vh'}
            onChange={onEditorValChange}
          />
          <span
            onClick={() => {
              setShowCommandModal(true);
              setEditorField(editorField);
            }}
            className='open-editor-icon'
          >
            <FontAwesomeIcon
              className='icon-full-screen k-mr-1'
              icon={faExpand}
            />
          </span>
        </>
      )}
    </>
  );
};

export default CommandField;
